import {
  Avatar,
  Box,
  Typography,
  useTheme,
  Select,
  MenuItem,
} from "@mui/material";
import React, { useEffect } from "react";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import { useState } from "react";
import Pagination from "@mui/material/Pagination";
import { tokens } from "../../theme";
import { ACTIVITY_PERIODS } from "../../constants/Constant";
import * as CONSTANT from "../../constants/Constant";

import PdfViewerDialog from "./PdfViewerDialog";
import DebugLog from "../../utils/DebugLog";
import { ALERT, ERROR, ERROR_FOUND_DURING_API_CALL, ERROR_WHILE_FETCHING_DATA, NO_INTERNET_CONNECTION_FOUND, PROCESSING_PLEASE_WAIT, SOME_ERROR_OCCURRED } from "../../constants/Strings";
import ConnectionStatus from "../../utils/ConnectionStatus";
import CustomProgressDialog from "../../components/CustomProgressDialog";
import { LOGIN_ID, MESSAGE_KEY, SESSION_ID, USER_NAME } from "../../constants/LocalStorageKeyValuePairString";
import { getFromLocalStorage } from "../../utils/localStorageUtils";
import { generateRequestId } from "../../utils/RequestIdGenerator";
import { initializeEncryption } from "../../services/AesGcmEncryption";
import { ApiErrorCode, ApiType } from "../../services/ApiTags";
import UseOnlineStatus from "../../utils/UseOnlineStatus";
import { showErrorAlertDialog } from "../../config/AppConfig";
import { useAtom } from "jotai";
import { downloadPdfViewerData } from "../../services/ApiService";
import { useNavigate } from "react-router-dom";
import ShowErrorAlertDialog from "../../components/ErrorAlertDialog";
import '@react-pdf-viewer/core/lib/styles/index.css';

const UserActivityInfoExclusionPage = ({
  sectionHeading,
  sectionIcon,
  type,
  data,
  ondateRangeChange: onDateRangeChange,
  totalNoOfPages,
  onPageChange,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const navigate = useNavigate();
  const [activityDetails, seteActivityDetails] = useState([]);
  const [dateRange, setDateRange] = useState(ACTIVITY_PERIODS.THREE_MONTHS);

  const isNetworkConnectionAvailable = UseOnlineStatus();
  const [loading, setLoading] = useState(false);
  const [getProgressbarText, setProgressbarText] = useState("");
  const [getDialogStatus, setErrorDialog] = useAtom(showErrorAlertDialog);

  const [title, setTitle] = useState(ALERT);
  const [content, setContent] = useState("");
  const [, setError] = useState("");

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  // const itemsPerPage = pageSize;

  // const indexOfLastItem = currentPage * itemsPerPage;
  // const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  // const currentItems = activityDetails.slice(indexOfFirstItem, indexOfLastItem);
  // const pageCount = Math.ceil(activityDetails.length / itemsPerPage)

  const pageCount = totalNoOfPages ? totalNoOfPages : 1;

  const [open, setOpen] = useState(false);
  const [commentData, setComment] = useState("");
  const [pdfData, setPdfData] = useState(null);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDateRangeChange = (event) => {
    setDateRange(event.target.value);
    onDateRangeChange(event.target.value);
  };

  useEffect(() => {
    if (data) {
      seteActivityDetails(data);
    }
  }, [data,isNetworkConnectionAvailable]);

  const handlePageChange = (value) => {
    setCurrentPage(value);
    onPageChange(value - 1); // Index starts from 0 for data array
  };

  const showAttachment = (attachmentId,refrenceNo,comment) => {
    setComment(comment)
     downloadViewablePdf(attachmentId,refrenceNo)
    //setOpen(true)
    //setPdfData("https://www.clickdimensions.com/links/TestPDFfile.pdf");
   
  };

  const getInitials = (name) => {
    // check if name is null or empty
    if (!name) return "";

    const words = name.split(" ");
    const initials = words
      .slice(0, 2)
      .map((word) => word[0])
      .join("")
      .toUpperCase();
    return initials;
  };

  function showErrorAlert(title, content) {
    try {
      DebugLog("an error found====" + content);
      setError();
      setLoading(false);

      setTitle(title);
      setContent(content);
      setErrorDialog(true);
    } catch (error) {
      DebugLog(error);
    }
  }

   function openPdfViewerDialog(response){
    const blob =  response.blob();
    const url = URL.createObjectURL(blob);
    setPdfData(url);
    setOpen(true)
  }

  async function downloadViewablePdf(referenceId,attachmentType) {
   try {
     if (isNetworkConnectionAvailable) {
       setProgressbarText(PROCESSING_PLEASE_WAIT);
       setLoading(true); // Hide the progress dialog

      //  const requestData = {
      //   attachmentType: attachmentType,
      //   referenceId:referenceId ,
      //  };

    

       const requestData = {
        attachmentType: attachmentType,
        referenceId: "78d03753-1780-412e-82f9-b8d5aae6a3ba",
       };

       initializeEncryption(
         requestData,
         getFromLocalStorage(MESSAGE_KEY),
         ApiType.EXCLUSION_FILE_READ
       ).then((encryptedContentData) => {
         const addExclusionRequestData = {
           requestId: generateRequestId(),
           loginId: getFromLocalStorage(LOGIN_ID),
           sessionId: getFromLocalStorage(SESSION_ID),
           contentData: encryptedContentData,
           loginUserName: getFromLocalStorage(USER_NAME),
         };

         downloadPdfViewerData(addExclusionRequestData)
           .then((response) => {
            // if (response.data.responseCode === "0") {
              openPdfViewerDialog(response)
              // const blob = response.data.result.blob();
              // const url = URL.createObjectURL(blob);
              // setPdfData(url);
              // setOpen(true)
            // }

             setLoading(false);
           })
           .catch((error) => {
            if (error.data.errorCode === ApiErrorCode.SESSION_EXPIRED) {
              navigate(CONSTANT.LOGIN)
            }
           else 
             if (error.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND) {
               try {
                 navigate("/");
               } catch (error) {
                 DebugLog("error " + error);
               }
             } else {
              const message =
              error.data != null
                ? error.data.displayErrorMessage
                : SOME_ERROR_OCCURRED;

            if (message)
              showErrorAlert(
                ERROR,
                ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
              );
             }
           });
       });
     } else {
       showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
     }
   } catch (error) {
     const message = error.response != null ? error.response : error.message;
     showErrorAlert(
       error.message,
       ERROR_FOUND_DURING_API_CALL + JSON.stringify(message)
     );
   }
 }

 
  return (

    <Box style={{ width: "100%" }}>
       <ShowErrorAlertDialog
          status={getDialogStatus}
          title={title}
          content={content}
        />
       <ConnectionStatus />
        {isNetworkConnectionAvailable ? (
          <CustomProgressDialog open={loading} text={getProgressbarText} />
        ) : (
         ""
        )}
      <PdfViewerDialog
        open={open}
        handleClose={handleClose}
        downloadPdf={handleClose}
        pdfUrl={pdfData}
        comment={commentData}
      ></PdfViewerDialog>
   
    {/* <div style={{ width: "100%" }}>
      <Box sx={{ p: 3, m: 1, display: "flex" }}> */}

      <Box sx={{ width: "100%" }}>

        {activityDetails.length > 0 ? (
          <Grid
            container
            direction={"column"}
            mt={3}
            p={3}
            xs={12}
            mb={20}
            sx={{
              background: colors.grey[900],
              borderRadius: "12px",
            }}
          >
          
            <Grid container fontSize={20} fontWeight={700}>
              {/* Activity Header */}
              <Grid item xs={6}>
                Activity
              </Grid>

              {/* Time Period Dropdown */}
              <Grid item xs={6}>
                <Box display="flex" justifyContent="flex-end">
                  <Select
                    value={dateRange}
                    onChange={handleDateRangeChange}
                    displayEmpty
                    inputProps={{
                      "aria-label": "Select a time period",
                    }}
                    sx={{
                      height: "30px",
                      "& .MuiSelect-select": {
                        height: "30px",
                        display: "flex",
                        alignItems: "center",
                      },
                    }}
                    // IconComponent={"../../assets/common/Arrow-down.svg"}
                  >
                    {/* Create a menu item for each activity period defined in constants */}
                    {Object.values(ACTIVITY_PERIODS).map((period) => (
                      <MenuItem key={period} value={period}>
                        {period}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
              </Grid>
            </Grid>

            {activityDetails.map((row) => (
              // Activity Row //
              <Grid item key={row.id} xs={12}>
                <Grid
                  container
                  direction={"row"}
                  mt={2}
                  spacing={2}
                  alignItems={"center"}
                >
                  {/* Avatar */}
                  <Grid item xl={0.5} lg={0.65} md={1} sm={1.5}>
                    <Avatar
                      sx={{
                        bgcolor: colors.grey[900],
                        color: colors.grey[100],
                        border: "1px solid #888888",
                      }}
                    >
                      {getInitials(row.clientName)}
                    </Avatar>
                  </Grid>

                  {/* Content */}
                  <Grid item xl={9.5} lg={9.35} md={9} sm={8.5}>
                    <Typography>
                      <Box>
                        <span style={{ fontWeight: 600 }}>{row.createdBy}</span>
                        <span> </span>
                        <span>{row.action}</span>
                        <span> </span>
                        <span style={{ fontWeight: 600 }}>
                          {row.clientName}
                        </span>
                      </Box>
                    </Typography>

                    {row.attachmentReferenceId &&
                      row.attachmentReferenceId !== "null" && (
                        <Grid item sx={{ overflowY: "auto" }}>
                          {/* <Box> */}
                            <Typography>
                              <span
                                style={{
                                  fontWeight: 500,
                                  color: colors.primary[100],
                                }}
                                onClick={() =>
                                  showAttachment(row.attachmentReferenceId,row.referenceType,row.comment)
                                }
                              >
                                Attachment (Proof){" "}
                              </span>
                              {/* {row.attachmentReferenceId} */}
                            </Typography>
                          {/* </Box> */}
                        </Grid>
                      )}

                    {row.reason && (
                      <Grid item sx={{ overflowY: "auto" }}>
                        <Typography>
                          <span style={{ fontWeight: 600 }}>Reason: </span>
                          {row.reason}
                        </Typography>
                      </Grid>
                    )}
                  </Grid>

                  {/* Date Time */}
                  <Grid
                    item
                    xl={2}
                    lg={2}
                    md={2}
                    sm={2}
                    sx={
                      {
                        textAlign: "right"
                        // position: 'relative',
                        // right: '-10%',
                        // color: colors.grey[300],
                      }
                    }
                  >
                    <Typography variant="h7"> {row.createdOn}</Typography>
                  </Grid>
                </Grid>
              </Grid>
              // Activity Row //
            ))}

            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              sx={{ marginTop: 3 }}
            >
              <Pagination
                count={pageCount}
                page={currentPage}
                onChange={(event, value) => handlePageChange(value)}
              />
            </Box>

            <Typography sx={{ marginTop: 2 }}>
              <span>Jump to page: </span>
              <select
                value={currentPage}
                onChange={(event) =>
                  handlePageChange(Number(event.target.value))
                }
                sx={{ marginRight: 2 }}
              >
                {[...Array(pageCount)].map((_, index) => (
                  <option key={index} value={index + 1}>
                    {index + 1}
                  </option>
                ))}
              </select>
            </Typography>
          </Grid>
        ) : (
          ""
        )}
      </Box>
</Box>
  );
};

export default UserActivityInfoExclusionPage;
